import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';

const GreetingsDateInput = forwardRef(({ value, onClick }, ref) => (
  <div className="position-relative">
    <Form.Control
      size="sm"
      ref={ref}
      onClick={onClick}
      value={value}
      className="ps-4"
      // onChange={e => {
      //   console.log({ e });
      // }}
    />
    <FontAwesomeIcon
      icon="calendar-alt"
      className="text-primary position-absolute top-50 translate-middle-y ms-2"
    />
  </div>
));

const FilterDate = ({ onDateChange, startDate, endDate, isVisibleDate = true }) => {
  const [selectedStartDate, setSelectedStartDate] = useState(startDate);
  const [selectedEndDate, setSelectedEndDate] = useState(endDate);

  const onChange = dates => {
    const [start, end] = dates;
    setSelectedStartDate(start);
    setSelectedEndDate(end);
    
    if (start && end) {
      const formatStart = format(new Date(start), 'yyyy-MM-dd');
      const formatEnd = format(new Date(end), 'yyyy-MM-dd');
      onDateChange(` BETWEEN '${formatStart}' and '${formatEnd}' `);
    }
  };

  // Atualiza os estados quando as props mudam
  useEffect(() => {
    setSelectedStartDate(startDate);
    setSelectedEndDate(endDate);
  }, [startDate, endDate]);

  return (
    <>
      {isVisibleDate && (
        <DatePicker
          selected={selectedStartDate}
          onChange={onChange}
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          selectsRange
          dateFormat="dd/MM/yy"
          customInput={<GreetingsDateInput />}
        />
      )}
    </>
  );
};

GreetingsDateInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func
};

FilterDate.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  isVisibleDate: PropTypes.bool
};

export default FilterDate;